export const TOPIC_COMPONENT_PATH = "/topic_component";

export const TOPIC_FLOW_ROUTES = {
  exercise: {
    instruction: "/topic_component/exercise-instruction",
    test: "/topic_component/exercise-test",
    summary: "/topic_component/exercise-summary",
  },
  dpp: {
    instruction: "/topic_component/dpp-instruction",
    test: "/topic_component/dpp-test",
    summary: "/topic_component/dpp-summary",
  },
  pyq: {
    instruction: "/topic_component/pyq-instruction",
    test: "/topic_component/pyq-test",
    summary: "/topic_component/pyq-test-summary",
  },
  homework: {
    instruction: "/homework-instruction",
    test: "/homework-test",
    summary: "/homework-summary",
  },
};

export const STANDALONE_FLOW_ROUTES = {
  exercise: {
    instruction: "/exercise-instruction",
    test: "/exercise-test",
    summary: "/exercise-summary",
  },
  dpp: {
    instruction: "/dpp-instruction",
    test: "/dpp-test",
    summary: "/exercise-summary",
  },
  pyq: {
    instruction: "/pyq-instruction",
    test: "/pyq-test",
    summary: "/pyq-test-summary",
  },
  homework: {
    instruction: "/homework-instruction",
    test: "/homework-test",
    summary: "/homework-summary",
  },
};

export const isTopicComponentPath = (pathname) =>
  String(pathname || "").startsWith(TOPIC_COMPONENT_PATH);

export const getTopicFlowRoutes = (flowType, pathname) => {
  const flow = TOPIC_FLOW_ROUTES[flowType] ? flowType : "exercise";
  return isTopicComponentPath(pathname)
    ? TOPIC_FLOW_ROUTES[flow]
    : STANDALONE_FLOW_ROUTES[flow];
};
